import type { ICampaign } from "../../../../../types/models/campaign.models.types";
import { useGetHttp } from "../../../http.hook";

interface IResponse {
  campaign: ICampaign;
}

export function useGetCampaignBriefCommonHttp() {
  return useGetHttp<IResponse>({
    path: "/common/utils/campaign-brief",
  });
}
